module.exports = __webpack_public_path__ + "static/media/learn.b9323702.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/learn.svg
// module id = 467
// module chunks = 0